import { render, staticRenderFns } from "./ExpertLookup.vue?vue&type=template&id=40902291&"
import script from "./ExpertLookup.vue?vue&type=script&lang=js&"
export * from "./ExpertLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports